import React from "react"
import CommisionersDirectorsPage from "components/pages/investor/commissioners-directors"

const CaDEn = (props) => <CommisionersDirectorsPage {...props} />

export default CaDEn